export enum ElementId {
  RewardDropdownLabelText = 'rewardDropdownLabelText',
  RewardDropdown = 'rewardDropdown',
  Error = 'error',
  ErrorText = 'errorText',
  StatusText = 'statusText',
}
